import React, { useState, useRef, useCallback, useContext } from 'react';
import columns from './columns';
import { useAuth } from 'contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Table, Icon } from 'components';
import { ListContext } from 'contexts/ListContext';
import { updateUser } from 'services/users';
import Swal from 'sweetalert2';
import { showError } from 'utils/alerts';

export const UsersTable = () => {
	const { user } = useAuth();
	const { t } = useTranslation();
	const { list, listData, setListData, fetching, fetchList } =
		useContext<any>(ListContext);

	const removeUser = async (selected: any) => {
		const selectedIsActive = selected?.isActive;
		Swal.fire({
			title: t('areYouSure'),
			text: selectedIsActive
				? t('doYouWantToInactivate', {
						element: t('user'),
						name: selected?.nickname,
				  })
				: t('doYouWantToActivate', {
						element: t('user'),
						name: selected?.nickname,
				  }),
			icon: 'question',
			confirmButtonText: t('yes'),
			showCancelButton: true,
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					await updateUser(selected.id, { isActive: !selectedIsActive });
					await fetchList();
				} catch (error) {
					showError(`Error on trying to inactive user ${selected?.nickname}.`);
				}
			}
		});
	};

	const [loading, setLoading] = useState(false);
	const fetchIdRef = useRef(0);

	const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
		try {
			setListData({ ...listData, currentPage: pageIndex, size: pageSize });
			setLoading(true);
			const fetchId = ++fetchIdRef.current;
			if (fetchId === fetchIdRef.current) {
				const res = await fetchList(pageIndex, pageSize);
			}
		} catch (error) {
			Swal.fire({
				title: 'Error',
				text: 'Hubo un problema intentando obtener los usuarios, vuelva a intentar',
			});
			console.log({ error });
		} finally {
			setLoading(false);
		}
	}, []);

	return (
		<Table
			cols={columns}
			fetchData={fetchData}
			loading={loading || fetching}
			pageCount={listData?.totalPages}
			noDataMsg={t('noUsers')}
			totalItems={listData?.totalItems}
			removeFunction={removeUser}
			data={list}
		/>
	);
};
